import type { ConfigColor, ConfigColors } from "../../envConfig";

// Always make sure red color is the first in the array (is selected for defaullt color for lines and polygons)
export const defaultColors = [
  { border: "white", fill: [235, 0, 0, 1], hex: "#eb0000", name: "red" },
  { border: "black", fill: [255, 204, 0, 1], hex: "#ffcc00", name: "yellow" },
  {
    border: "black",
    fill: [255, 138, 61, 1],
    hex: "#ff8a3d",
    name: "orange",
  },
  { border: "black", fill: [0, 135, 90, 1], hex: "#00875a", name: "green" },
  { border: "white", fill: [0, 0, 0, 1], hex: "#000000", name: "black" },
  {
    border: "black",
    fill: [255, 255, 255, 1],
    hex: "#ffffff",
    name: "white",
  },
] as ConfigColor[];

export default {
  colors: defaultColors,
  iconGeneratorColors: defaultColors,
  lineColors: defaultColors,
  polygonFillColors: defaultColors,
  polygonLineColors: defaultColors,
  textBgColors: [
    { fill: [255, 255, 255, 0.01], name: "none" },
    ...defaultColors,
  ],
} as ConfigColors;
